import { Box } from '@mui/material';
import React from 'react';
import ElementDataRow from 'components/common/element-data/ElementDataRow';
import { ElementMetadataFieldName, IElementDataLinkedReports } from 'components/common/element-data/types';
import { buildDrillToLinkedReport } from 'components/element-viewer';
import { getFieldElementMetadataSettings } from 'components/common/element-data/functions';

export default function LinkedReports(props: IElementDataLinkedReports) {
    const { linkedReports = [], settings } = props;
    const fieldKey: ElementMetadataFieldName = 'linked_reports';
    const { fieldMetadataDisplay, fieldMetadataOrder } = getFieldElementMetadataSettings(settings, fieldKey);

    if (!fieldMetadataDisplay || linkedReports.length == 0) return null;

    return (
        <ElementDataRow order={fieldMetadataOrder}>
            {linkedReports.map((linkedReportItem) => (
                <Box key={linkedReportItem.id}>
                    <Box
                        component="a"
                        className={'default-link'}
                        href={buildDrillToLinkedReport(linkedReportItem)}
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        {linkedReportItem.drill_to_label}
                    </Box>
                </Box>
            ))}
        </ElementDataRow>
    );
}
